/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { WhseJob060101Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const whseJob060101ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  // selectedDocuments: INITIAL_STATE.selectedDocuments,
  fetchIsLoading: false,
  printIsLoading: false
});

export const whseJob060101FetchWhseJob060101Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const whseJob060101FetchWhseJob060101Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const whseJob060101AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ].slice(0, 5)
  };
};

export const whseJob060101RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const whseJob060101SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const whseJob060101PrintWhseJob060101Loading = (state, { boolean }) => ({
  ...state,
  printIsLoading: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [WhseJob060101Types.WHSE_JOB060101_RESET_TIMESTAMP]: whseJob060101ResetTimestamp,
  [WhseJob060101Types.WHSE_JOB060101_FETCH_WHSE_JOB060101_LOADING]: whseJob060101FetchWhseJob060101Loading,
  [WhseJob060101Types.WHSE_JOB060101_FETCH_WHSE_JOB060101_SUCCESS]: whseJob060101FetchWhseJob060101Success,
  [WhseJob060101Types.WHSE_JOB060101_ADD_SELECTED_DOCUMENTS]: whseJob060101AddSelectedDocuments,
  [WhseJob060101Types.WHSE_JOB060101_REMOVE_SELECTED_DOCUMENTS]: whseJob060101RemoveSelectedDocuments,
  [WhseJob060101Types.WHSE_JOB060101_SET_WORKSPACE_VISIBLE]: whseJob060101SetWorkspaceVisible,
  [WhseJob060101Types.WHSE_JOB060101_PRINT_WHSE_JOB060101_LOADING]: whseJob060101PrintWhseJob060101Loading
});
